/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

export type BTAdminBuilderPreference =
  (typeof BTAdminBuilderPreference)[keyof typeof BTAdminBuilderPreference];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BTAdminBuilderPreference = {
  notificationHistoryRedesign: "notificationHistoryRedesign",
  taskManagementOptIn: "taskManagementOptIn",
  estimateCostCodeGroupModifications: "estimateCostCodeGroupModifications",
  jcbMarkupTaxLogicSwitch: "jcbMarkupTaxLogicSwitch",
  accountingServiceQboInvoiceSync: "accountingServiceQboInvoiceSync",
  costCodeSettingsAgGrid: "costCodeSettingsAgGrid",
  subsAuth0Migration: "subsAuth0Migration",
  permissionsMfaEnrollmentCohort: "permissionsMfaEnrollmentCohort",
  rFIOwnersV1: "rFIOwnersV1",
  worksheetAGGrid: "worksheetAGGrid",
  estimateMobileServices: "estimateMobileServices",
  sageARPayments: "sageARPayments",
  sageSync: "sageSync",
  paymentMethodUI: "paymentMethodUI",
  paymentsSetupTab: "paymentsSetupTab",
  tasksGeneralJob: "tasksGeneralJob",
  billsFullPageConversion: "billsFullPageConversion",
  budgetCostCodeCaching: "budgetCostCodeCaching",
  changeOrdersNewItemHeader: "changeOrdersNewItemHeader",
  bulkExport: "bulkExport",
  selectionOptionHeroImage: "selectionOptionHeroImage",
  sageIntacctMVP: "sageIntacctMVP",
  taskDependencies: "taskDependencies",
  enterSubPaymentContactInfo: "enterSubPaymentContactInfo",
  editBillPercentage: "editBillPercentage",
  timeClockLegacyGeneralJobCleanup: "timeClockLegacyGeneralJobCleanup",
  lienWaiversMassPay: "lienWaiversMassPay",
  jcbNestedCostCategories: "jcbNestedCostCategories",
  useNotificationsEmail: "useNotificationsEmail",
  selfServiceMfaManagement: "selfServiceMfaManagement",
  taskGantt: "taskGantt",
  scopeOfWorkMobileCardView: "scopeOfWorkMobileCardView",
  tasksCustomFieldSortTweaks: "tasksCustomFieldSortTweaks",
  allocateBillCostsAcrossMultipleJobs: "allocateBillCostsAcrossMultipleJobs",
  costCodeSettingsRedesign: "costCodeSettingsRedesign",
  customForwardEmailAlias: "customForwardEmailAlias",
  partialPaymentLienWaivers: "partialPaymentLienWaivers",
  selectionsReimagined: "selectionsReimagined",
  aIASignatureWorkflow: "aIASignatureWorkflow",
  sageInvoice: "sageInvoice",
  gustoUpgrade: "gustoUpgrade",
  massShiftDelete: "massShiftDelete",
  progressInvoiceRevisedBudgetColumn: "progressInvoiceRevisedBudgetColumn",
  tasksRequireCompletedSubtasks: "tasksRequireCompletedSubtasks",
  xeroReconnectAfterError: "xeroReconnectAfterError",
  aiaPurchaseOrder: "aiaPurchaseOrder",
  disableToDos: "disableToDos",
  useRemoteEmailClassification: "useRemoteEmailClassification",
  lowesInCompanySettings: "lowesInCompanySettings",
  infoArchOptIn: "infoArchOptIn",
  selectionsCatalogCreate: "selectionsCatalogCreate",
  vendorCreditOCRDetection: "vendorCreditOCRDetection",
  subMissingPaymentInfoOnBill: "subMissingPaymentInfoOnBill",
  trackAllowanceProgress: "trackAllowanceProgress",
  mobileInAppFeedback: "mobileInAppFeedback",
  watchingForTasks: "watchingForTasks",
  achBankSetupEmailPreview: "achBankSetupEmailPreview",
  billAccountingSyncMoment: "billAccountingSyncMoment",
  offlinePartialBillPaymentsNoAccounting:
    "offlinePartialBillPaymentsNoAccounting",
  progressInvoicePreviousAmountRecalc: "progressInvoicePreviousAmountRecalc",
  invoiceCreationAlignment: "invoiceCreationAlignment",
  requireStepUpAuthForOutboundPayments: "requireStepUpAuthForOutboundPayments",
  tasksCalendarFeed: "tasksCalendarFeed",
  schedulePagedGanttPrint: "schedulePagedGanttPrint",
  autoFillInvoice: "autoFillInvoice",
  taxesChangeOrders: "taxesChangeOrders",
  estimateActivityLog: "estimateActivityLog",
  billPaymentScheduling: "billPaymentScheduling",
  bulkRoleManagement: "bulkRoleManagement",
  mobileWebviewExperience: "mobileWebviewExperience",
  taskDependenciesShifting: "taskDependenciesShifting",
  paymentsControllerRefactor: "paymentsControllerRefactor",
  multiInvoicePdfSplitDetectionReview: "multiInvoicePdfSplitDetectionReview",
  finalUnconditionalLienWaivers: "finalUnconditionalLienWaivers",
  multipleLienWaiversOnBills: "multipleLienWaiversOnBills",
  invoiceRelatedEntityLineItemTags: "invoiceRelatedEntityLineItemTags",
  sharePaymentScheduleOnAllFixedPriceJobs:
    "sharePaymentScheduleOnAllFixedPriceJobs",
  paymentScheduleAfterSendToBudget: "paymentScheduleAfterSendToBudget",
  costInboxMigration: "costInboxMigration",
  disableSubOwnerExternalEmails: "disableSubOwnerExternalEmails",
  taskPhaseDemo: "taskPhaseDemo",
  qbdWebConnectorHangfireDefer: "qbdWebConnectorHangfireDefer",
  billsAgGridMigration: "billsAgGridMigration",
  aIEstimate: "aIEstimate",
  aIPreliminaryEstimate: "aIPreliminaryEstimate",
  selectionOptionsLineItemCard: "selectionOptionsLineItemCard",
  specPublishPushNotifications: "specPublishPushNotifications",
  enableSpecPublishNotifications: "enableSpecPublishNotifications",
  genericLinkingSpecsToCO: "genericLinkingSpecsToCO",
  legacyLinkingPlansAndSpecsToCO: "legacyLinkingPlansAndSpecsToCO",
  specInternalOnlyPublish: "specInternalOnlyPublish",
  fieldNotes: "fieldNotes",
  linkPlansToSubmittals: "linkPlansToSubmittals",
  quickBooksMigrationInvoices: "quickBooksMigrationInvoices",
  plansMultiDocRevisions: "plansMultiDocRevisions",
  specificationGroups: "specificationGroups",
  messagesAllowMobileVideoUploads: "messagesAllowMobileVideoUploads",
  searchUxRedesign: "searchUxRedesign",
  taskAssistantOptIn: "taskAssistantOptIn",
  taxesSelectionChoices: "taxesSelectionChoices",
  globalSpecCostGroupLinking: "globalSpecCostGroupLinking",
  tasksNonWorkingDays: "tasksNonWorkingDays",
  dailyLogsAutoSave: "dailyLogsAutoSave",
  plansAiVersionSummary: "plansAiVersionSummary",
  leadsFullPageConversion: "leadsFullPageConversion",
  splitBillsPOsBudgetSettings: "splitBillsPOsBudgetSettings",
  mobileDirectoryAddExperience: "mobileDirectoryAddExperience",
  whatsNewPanel: "whatsNewPanel",
  massShiftCreation: "massShiftCreation",
  defaultSpcOn: "defaultSpcOn",
  aiPoweredSearch: "aiPoweredSearch",
  selectionsReimaginedSignatures: "selectionsReimaginedSignatures",
  offlinePartialBillPaymentsAccounting: "offlinePartialBillPaymentsAccounting",
  invoiceTaxColumnPresentation: "invoiceTaxColumnPresentation",
  convertLegacyTemplateToSRI: "convertLegacyTemplateToSRI",
  specsRelatedItemLinkEnhancements: "specsRelatedItemLinkEnhancements",
  scheduleCompleteInvoiceReadyNotification:
    "scheduleCompleteInvoiceReadyNotification",
  templateSupportForSelectionOptions: "templateSupportForSelectionOptions",
  expenseAccountingSync: "expenseAccountingSync",
  warrantiesModalConversion: "warrantiesModalConversion",
  legacyBuildersSriTemplateSupport: "legacyBuildersSriTemplateSupport",
} as const;
